var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UiLayoutHeader',{staticClass:"header"},[_c('HeaderLogo'),_c('HeaderDivider'),_c('HeaderTitle',{staticClass:"d-none d-sm-block"}),_c('template',{slot:"extra"},[_c('div',{staticClass:"d-none d-sm-block"},[_c('UIButton',{staticClass:"d-none"},[_vm._v(" "+_vm._s(_vm.$t('bi.header.help'))+" ")]),_c('CButtonFeedback')],1),_c('BLanguage')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }